import { createWebHistory, createRouter } from "vue-router";
import { routes } from "./routes";
import { resolveTenantIdForNavigation } from "./guards";

function normalizeRouterPath(path) {
  if (!path) return "";
  const trimmed = String(path).replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}

const router = createRouter({
  history: createWebHistory(),
  routes,
});

router.beforeEach((to, from, next) => {
  if (to.name !== "Login" && to.name !== "NotFound") {
    const firstSeg = to.path.split("/").filter(Boolean)[0];
    if (firstSeg && firstSeg !== "login") {
      localStorage.setItem("lastView", to.fullPath);
    }
  }
  if (to.name === "Board") {
    localStorage.setItem("lastVisitedDashboard", to.fullPath);
  }

  if (to.matched.length === 0 && to.name !== "Login") {
    const tenantId = resolveTenantIdForNavigation();
    if (tenantId) {
      const segments = to.path.split("/").filter(Boolean);
      const rest =
        segments.length > 0 && segments[0] === tenantId
          ? segments.slice(1)
          : segments;
      let rebuilt =
        rest.length > 0 ? `/${tenantId}/${rest.join("/")}` : null;
      if (!rebuilt) {
        const lastView = localStorage.getItem("lastView");
        if (lastView && String(lastView).startsWith("/")) {
          const lastSeg = String(lastView)
            .split("?")[0]
            .split("/")
            .filter(Boolean);
          if (lastSeg[0] === tenantId && lastSeg.length > 1) {
            rebuilt = String(lastView).split("?")[0];
          }
        }
      }
      if (!rebuilt) {
        rebuilt = `/${tenantId}/data-management`;
      }
      const nTo = normalizeRouterPath(to.path);
      const nRebuilt = normalizeRouterPath(rebuilt);
      if (nRebuilt !== nTo) {
        return next({
          path: rebuilt,
          query: to.query,
          hash: to.hash,
          replace: true,
        });
      }
    }
  }

  next();
});

export default router;
